import Conversation from '../conversation/conversation.vue'

const conversationPage = {
  components: {
    Conversation
  },
  props: {
    isSinglePostView: false
  },
  computed: {
    statusId () {
      return this.$route.params.id
    }
  }
}

export default conversationPage
